module.exports = require("rxjs/observable/empty");


//////////////////
// WEBPACK FOOTER
// external "rxjs/observable/empty"
// module id = 821
// module chunks = 0